module.exports = __webpack_public_path__ + "components/t-shirt-comp/static/Playade-Berria-81a06b22705ae415dc985a980864dc6a.jpg";